import { render } from "./DonationsList.vue?vue&type=template&id=561059e2&scoped=true"
import script from "./DonationsList.vue?vue&type=script&lang=js"
export * from "./DonationsList.vue?vue&type=script&lang=js"

import "./DonationsList.vue?vue&type=style&index=0&id=561059e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561059e2"]])

export default __exports__